define([
    'jquery',
    'common/constants',
    'framework/uriManager',
    'framework/services',
    'framework/serviceManager',
    'framework/storageManager',
    'framework/layouts',
    'features/userPreferences/userPreferences',
    'framework/config',
    'services/featureFlagService'
], function(
    $,
    constants,
    uri,
    services,
    serviceManager,
    storageManager,
    layouts,
    userPreferences,
    config,
    featureFlagService) {
    'use strict';

    return {
        options: {},
        deferred: null,
        case: {},

        fetchAuth: function () {
            let sessionId = storageManager.get(constants.ADVANCED_SESSION_KEY);
            if (!sessionId) {
                sessionId = -1;
            }

            return serviceManager.exec({
                url: services.getUrl('user.data', {}),
                params: sessionId + '',
                type: 'POST',
                timeout: constants.API_USER_TIMEOUT
            }).done((response, status, xhr) => {
                storageManager.set(constants.ADVANCED_SESSION_KEY, response.userSessionId);
                window.userSessionId = response.userSessionId;
                //US496779 Store the access token in local storage instead of session
                localStorage.setItem(constants.ACCESS_TOKEN_KEY, xhr.getResponseHeader('x-access-token'));
                window.EMPID = response.userSessionId + '';
            });
        },

        fetchUser: function(strViewer) {
            const context = this;
            this.deferred = new $.Deferred();

            if (strViewer === 'index' && uri.get('extended') === '1' || strViewer === 'browser' && uri.get('extended') === '1') {
                layouts.init();
                this.copyUserFromMainToExtendedWindow();
                this.deferred.resolve();
            } else {
                layouts.init();
                this.userdeferred = new $.Deferred();
                this.fitdeferred = new $.Deferred();

                this.fetchAuth().done((response) => {
                    this.fetchUserResponse(response);
                    this.userdeferred.resolve();
                }).fail((response) => {
                    this.userdeferred.reject(response);
                });

                serviceManager.exec({
                    url: services.getUrl('search.fitCountries'),
                    type: 'GET',
                    notification: false,
                    contentType: 'application/json; charset=UTF-8',
                    success: this.fetchFitConfigResponse.bind(this),
                    error: this.errorfetchFitConfigResponse.bind(this)
                });

                $.when(context.userdeferred, context.fitdeferred)
                    .done(function () {
                        context.deferred.resolve();
                    })
                    .fail(function (response) {
                        context.deferred.reject(response.status);
                    });
            }

            return this.deferred.promise();
        },

        fetchFitConfigResponse: function (response) {
            const isEmpty = !response;
            const isString = typeof response === 'string';
            if (isEmpty) {
                return this.fitdeferred.resolve();
            }

            response = isString ? JSON.parse(response) : response;
            window.fitConfig = response;
            userPreferences.setFitCountriesDefault();
            return this.fitdeferred.resolve();
        },

        errorfetchFitConfigResponse: function (response) {
            console.error('fit countries endpoint failed', response);
            return this.fitdeferred.reject(response);
        },

        copyUserFromMainToExtendedWindow: function() {
            if (window.opener) {
                window.userSessionId = window.opener.userSessionId;
                window.EMPID = window.opener.EMPID;
                window.caseId = window.opener.caseId;
                window.documentsLimitInQuery = window.opener.documentsLimitInQuery;
                window.sessionTimeOutTime = window.opener.sessionTimeOutTime;
            }
        },

        fetchUserResponse: function(response) {
            response = (typeof response === 'string') ? JSON.parse(response) : response;

            window.documentsLimitInQuery = response.documentsLimitInQuery || 1000;
            window.sessionTimeOutTime = response.sessionTimeOutTime || 900;
            window.caseId = response.userCase.caseId;
            window.SESSION.workSpace = {};
            window.SESSION.workSpace.caseGuid = response.userCase.caseName;
            config.setHostURLs(response.hostURLs);
            featureFlagService.setFeatureFlags(response.featureFlags);
            layouts.setLayout('QUICK');

            //load versions
            window.versions = response.versions;

            userPreferences.setUserPreferenceDefaults();

            //set cases info
            this.case = response.userCase;
        }
    };
});